/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import CalendarLocale from '../calendar/mn_MN';
import TimePickerLocale from '../time-picker/mn_MN';

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'ÐÐ³Ð½Ð¾Ð¾ ÑÐ¾Ð½Ð³Ð¾Ñ',
    rangePlaceholder: ['Ð­ÑÐ»ÑÑ Ð¾Ð³Ð½Ð¾Ð¾', 'ÐÑÑÑÐ°Ñ Ð¾Ð³Ð½Ð¾Ð¾'],
    ...CalendarLocale
  },
  timePickerLocale: {
    ...TimePickerLocale
  }
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;
